export default "__VITE_ASSET__07dd9820__"